import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type CarouselProps = {
  children: React.ReactNode;
  ariaLabel: string;
  itemClassName?: string;
};
export function Carousel({
  children,
  ariaLabel,
  itemClassName = ''
}: CarouselProps) {
  const trackRef = useRef<HTMLUListElement>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const updateEdges = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setAtStart(el.scrollLeft <= 8);
    setAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 8);
  }, []);
  useEffect(() => {
    updateEdges();
    window.addEventListener('resize', updateEdges);
    return () => window.removeEventListener('resize', updateEdges);
  }, [updateEdges]);
  const scrollBy = (direction: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({
      left: direction * el.clientWidth * 0.8,
      behavior: 'smooth'
    });
  };
  const items = React.Children.toArray(children);
  return <div className="relative" data-id="element-214" data-mp="1a94gph5tvkj9">
      <ul ref={trackRef} onScroll={updateEdges} aria-label={ariaLabel} className="carrusel flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth px-5 pb-4 sm:gap-6 sm:px-8 lg:px-12" data-id="element-215" data-mp="1aa62afkgzpf8">
        {items.map((child, index) => <li key={index} className={`w-[74%] shrink-0 snap-center sm:w-[46%] lg:w-[30%] xl:w-[24%] ${itemClassName}`} data-id="element-216" data-mp="11f87f2xri2l9" data-mpi={index}>
            {child}
          </li>)}
      </ul>

      <div className="mt-2 flex items-center justify-center gap-4" data-id="element-217" data-mp="rid8wk1ho26z">
        <button type="button" onClick={() => scrollBy(-1)} disabled={atStart} aria-label="Ver anteriores" className="flex h-12 w-12 items-center justify-center rounded-full border border-rosa-200 bg-white text-frambuesa shadow-tarjeta transition hover:bg-rosa-50 disabled:opacity-35" data-id="element-218" data-mp="mjifyp9t4x95">
          <ChevronLeftIcon className="h-6 w-6" aria-hidden="true" data-id="element-219" data-mp="2cwhmld9uy8gr" />
        </button>
        <button type="button" onClick={() => scrollBy(1)} disabled={atEnd} aria-label="Ver siguientes" className="flex h-12 w-12 items-center justify-center rounded-full border border-rosa-200 bg-white text-frambuesa shadow-tarjeta transition hover:bg-rosa-50 disabled:opacity-35" data-id="element-220" data-mp="2cun2u2abome9">
          <ChevronRightIcon className="h-6 w-6" aria-hidden="true" data-id="element-221" data-mp="1az01vjcz4ox" />
        </button>
      </div>
      <p className="mt-1 text-center font-sans text-sm text-suave sm:hidden" data-id="element-222" data-mp="5azf9iea7jx1">
        Deslizá con el dedo →
      </p>
    </div>;
}